import type { IconNode } from '../types';

/**
 * @name houses
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiAxN0gzYy0uNiAwLTEtLjQtMS0xVjguNUw4IDRsMTAgNy41VjE5YzAgLjYtLjQgMS0xIDFIN2MtLjYgMC0xLS40LTEtMXYtNy41TDE2IDRsNiA0LjVWMTZjMCAuNi0uNCAxLTEgMWgtMyIgLz4KICA8cGF0aCBkPSJNMTAgMjB2LTZoNHY2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/houses
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const houses: IconNode = [
  [
    'path',
    {
      d: 'M6 17H3c-.6 0-1-.4-1-1V8.5L8 4l10 7.5V19c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1v-7.5L16 4l6 4.5V16c0 .6-.4 1-1 1h-3',
      key: '11pmf2',
    },
  ],
  ['path', { d: 'M10 20v-6h4v6', key: '1mw2pl' }],
];

export default houses;
